import type { CatalogSiteLocale } from '../constants.js';
import { CATALOG_SITE_LOCALES } from '../constants.js';

export type CatalogUiStrings = {
  brand: string;
  brandShort: string;
  navCatalog: string;
  navTemplates: string;
  navCategoryPacks: string;
  navAuthors: string;
  navLists: string;
  /** Homepage header: open Discover instead of linking to self. */
  navDiscoverSpaces: string;
  navDevelopers: string;
  navDocs: string;
  navDocsDevelopers: string;
  navDocsHandbook: string;
  navDocsCompany: string;
  navTools: string;
  navToolsIos: string;
  navToolsAndroid: string;
  navToolsWeb: string;
  navToolsEditor: string;
  navEditor: string;
  navExploreLists: string;
  navGetApp: string;
  navCorporate: string;
  navAccount: string;
  navSignIn: string;
  navProfile: string;
  navViewProfile: string;
  navSettings: string;
  navSignOut: string;
  coercionLabel: string;
  coercionGetApp: string;
  coercionPublishWeb: string;
  coercionTemplatesUseful: string;
  coercionMakeTemplates: string;
  cornerRibbonText: string;
  cornerRibbonTitle: string;
  heroTitle: string;
  heroBlurb: string;
  featured: string;
  developers: string;
  filterName: string;
  filterNamePh: string;
  filterLanguage: string;
  filterAuthor: string;
  filterAuthorPh: string;
  filterClass: string;
  filterAny: string;
  filterAfter: string;
  filterBefore: string;
  filterStatus: string;
  filterEmpty: string;
  noPublic: string;
  languages: string;
  classes: string;
  none: string;
  moreInfo: string;
  itemsInTemplate: string;
  backToTemplate: string;
  officialExample: string;
  publishedWithTemplate: string;
  videoConsent: string;
  previews: string;
  video: string;
  videoOptional: string;
  forDevelopers: string;
  developerGuide: string;
  openInApp: string;
  downloadPackage: string;
  viewExampleList: string;
  downloadExampleCollection: string;
  openExampleInApp: string;
  downloadProject: string;
  exampleCollectionsHeading: string;
  noExampleCollections: string;
  updated: string;
  created: string;
  classHeading: string;
  classBlurb: (n: number) => string;
  noPublicClass: string;
  developersTitle: string;
  developersIntro: string;
  templatesHeading: string;
  templatesBlurb: string;
  templatesWhatLabel: string;
  templatesWhat: string;
  templatesInstallLabel: string;
  templatesInstall: string;
  templatesEditorLabel: string;
  templatesClassesLabel: string;
  templatesClasses: string;
  safetyHeading: string;
  safetyIntro: string;
  safetySandbox: string;
  safetyNotBrowser: string;
  safetyOfficial: string;
  installHeading: string;
  installPackageBlurb: string;
  installHowBlurb: string;
  installHostsBlurb: string;
  sampleHeading: string;
  noSamples: string;
  classesHeading: string;
  classesBlurb: string;
  backToCatalog: string;
  footerOfficial: string;
  footerEditor: string;
  footerCopyright: (year: number) => string;
  footerEula: string;
  footerPrivacy: string;
  footerTos: string;
  footerImprint: string;
  homeTitle: string;
  homeDescription: string;
  developersPageTitle: string;
  developersPageDescription: string;
  official: string;
  featuredBadge: string;
  statusAlpha: string;
  statusBeta: string;
  statusStable: string;
  statusPrerelease: string;
  releaseNotes: string;
  langSwitcherLabel: string;
  pagerPrev: string;
  pagerNext: string;
  pagerStatus: (page: number, totalPages: number, total: number) => string;
  documentTitleSuffix: string;
  whatsIncluded: string;
  includedItems: (n: number) => string;
  includedCategories: (n: number) => string;
  includedClasses: (n: number) => string;
  tabItems: string;
  tabCategories: string;
  tabClasses: string;
  addCategoriesWithoutTemplate: string;
  categoryImportWarning: string;
  downloadCategoriesJson: string;
  categoryPacksTitle: string;
  categoryPacksBlurb: string;
  noPublicCategoryPacks: string;
  addCategoriesInContaind: string;
  downloadJson: string;
  categoryPackWarning: string;
  includedInTemplates: string;
  notUsedInTemplate: string;
  authorsTitle: string;
  authorsBlurb: string;
  noPublicAuthorPackages: string;
  downloadForEditor: string;
  authorPackageHint: string;
  blocklyCaveat: string;
  authorKindClass: string;
  authorKindExpression: string;
  authorKindScript: string;
  compactCategories: string;
  siteNavAria: string;
  navMenuOpen: string;
  navMenuClose: string;
  footerReport: string;
  footerContact: string;
  favouriteTemplate: string;
  favouriteSaveError: string;
  favouriteRemoveError: string;
  pagerAria: string;
  recommendedGear: string;
  searchOnAmazon: string;
  amazonDisclosure: string;
  chromePreviewAlt: string;
  wikiTocAria: string;
  thTemplate: string;
  thAuthor: string;
  thExampleSpace: string;
  thPackage: string;
  thProject: string;
  templatePackageLink: string;
  sampleProjectLink: string;
  videoEmbedTitle: string;
};

const EN: CatalogUiStrings = {
  brand: 'Containd Template catalog',
  brandShort: 'Containd Spaces',
  navCatalog: 'Templates',
  navTemplates: 'Templates',
  navCategoryPacks: 'Category packs',
  navAuthors: 'For authors',
  navLists: 'Spaces',
  navDiscoverSpaces: 'Discover Spaces',
  navDevelopers: 'Docs',
  navDocs: 'Docs',
  navDocsDevelopers: 'Template Editors',
  navDocsHandbook: 'Editor handbook',
  navDocsCompany: 'Company',
  navTools: 'Tools',
  navToolsIos: 'Containd for Apple',
  navToolsAndroid: 'Containd for Android',
  navToolsWeb: 'Containd on the web',
  navToolsEditor: 'Template editor',
  navEditor: 'Editor',
  navExploreLists: 'Spaces',
  navGetApp: 'Get the app',
  navCorporate: 'Company',
  navAccount: 'Account',
  navSignIn: 'Sign in',
  navProfile: 'Profile & spaces',
  navViewProfile: 'View profile',
  navSettings: 'Settings',
  navSignOut: 'Sign out',
  coercionLabel: 'Get started',
  coercionGetApp: 'Make a Space — get the Containd app.',
  coercionPublishWeb: 'Make and publish Spaces online',
  coercionTemplatesUseful: 'See how Templates can help you',
  coercionMakeTemplates: 'Make Templates — open the editor.',
  cornerRibbonText: 'Early',
  cornerRibbonTitle: 'Early development — feedback welcome',
  heroTitle: 'Containd Template catalog',
  heroBlurb:
    'Official starter packs and templates for the Containd app. Browse, filter, and install — authoring lives in the template editor.',
  featured: 'Featured',
  developers: 'Docs',
  filterName: 'Name / text',
  filterNamePh: 'Name, class, …',
  filterLanguage: 'Language',
  filterAuthor: 'Author',
  filterAuthorPh: 'Containd',
  filterClass: 'Class',
  filterAny: 'Any',
  filterAfter: 'Updated after',
  filterBefore: 'Updated before',
  filterStatus: 'Release status',
  filterEmpty: 'No templates match these filters.',
  noPublic: 'No public templates yet.',
  languages: 'Languages',
  classes: 'Classes',
  none: 'None',
  moreInfo: 'More information',
  itemsInTemplate: 'Items in this template',
  backToTemplate: 'Back to template',
  officialExample: 'Official example Space',
  publishedWithTemplate: 'Published with this template',
  videoConsent: 'Allow video embeds in Privacy choices to play this overview.',
  previews: 'Previews',
  video: 'Video',
  videoOptional: 'Optional overview',
  forDevelopers: 'For developers',
  developerGuide: 'Docs & developer wiki',
  openInApp: 'Open in Containd',
  downloadPackage: 'Download template package',
  viewExampleList: 'View example Space',
  downloadExampleCollection: 'Download example collection',
  openExampleInApp: 'Open example in Containd',
  downloadProject: 'Download template project',
  exampleCollectionsHeading: 'Example collections',
  noExampleCollections:
    'No example collections published yet. Admins upload a collection ZIP separately and attach the URL on review.',
  updated: 'updated',
  created: 'created',
  classHeading: 'Class',
  classBlurb: (n) => `Templates that define or use this class (${n}).`,
  noPublicClass: 'No public templates',
  developersTitle: 'About templates',
  developersIntro:
    'A short guide to what templates are, how to install them, and how Containd keeps template scripts safe.',
  templatesHeading: 'What is a template?',
  templatesBlurb:
    'A template is a ready-made layout for Containd: item types, categories, and optional behaviour you can install into the app.',
  templatesWhatLabel: 'What’s inside',
  templatesWhat:
    'A downloadable package (JSON plus images and other media) that the Containd app understands.',
  templatesInstallLabel: 'How you use it',
  templatesInstall:
    'Install from this catalog into the app, or open an example Space on containd.space to see it in action.',
  templatesEditorLabel: 'Who builds them',
  templatesClassesLabel: 'Classes',
  templatesClasses:
    'Named building blocks inside a template. Catalog pages link templates that share the same class.',
  safetyHeading: 'Scripts and safety',
  safetyIntro:
    'Some templates include small scripts (for example timers or custom actions). That does not mean arbitrary code runs on this website.',
  safetySandbox:
    'In the Containd app, template scripts run only inside a js-interpreter sandbox — a restricted environment, not as normal unrestricted JavaScript on your device.',
  safetyNotBrowser:
    'Browsing this catalog or a published Space on the web does not execute those template scripts in your browser the way a normal website script would.',
  safetyOfficial:
    'Prefer Official catalog templates from authors you trust. Report suspicious content via the site’s Report content link.',
  installHeading: 'Install & packages',
  installPackageBlurb:
    'Each template package is a self-contained file at /packages/{slug}/{version}.json on this site.',
  installHowBlurb:
    'Install with the Open in Containd button, download the package and import it in Settings, or find templates in Discover inside the app.',
  installHostsBlurb:
    'Hosts: catalog.containd.app (this catalog) · containd.space (published Spaces) · editor',
  sampleHeading: 'Template project downloads',
  noSamples: 'No template projects published yet. Admins can attach a workspace/project JSON URL per entry.',
  classesHeading: 'Classes',
  classesBlurb:
    'Classes are shared building blocks. Each class page lists Official public templates that define or use that class.',
  backToCatalog: 'Back to templates',
  footerOfficial: 'Containd',
  footerEditor:
    'Spaces: containd.space · Templates: catalog.containd.app · Editor: templates.containd.app · Get app: www.containd.app',
  footerCopyright: (year) =>
    `© ${year} Next Level Order Engineering UG (haftungsbeschränkt)`,
  footerEula: 'EULA',
  footerPrivacy: 'Privacy Policy',
  footerTos: 'Terms of Service',
  footerImprint: 'Imprint',
  homeTitle: 'Containd Template catalog',
  homeDescription:
    'Official templates for the Containd app — search by name, language, author, class, date',
  developersPageTitle: 'About templates',
  developersPageDescription:
    'What Containd templates are, how to install them, and how template scripts stay sandboxed',
  official: 'Official',
  featuredBadge: 'featured',
  statusAlpha: 'Alpha',
  statusBeta: 'Beta',
  statusStable: 'Stable',
  statusPrerelease: 'Pre-release',
  releaseNotes: 'Release notes',
  langSwitcherLabel: 'Language',
  pagerPrev: 'Previous',
  pagerNext: 'Next',
  pagerStatus: (page, totalPages, total) =>
    total === 0 ? 'No results' : `Page ${page} of ${totalPages} · ${total} templates`,
  documentTitleSuffix: 'Containd',
  whatsIncluded: 'What’s included',
  includedItems: (n) => `${n} items`,
  includedCategories: (n) => `${n} categories`,
  includedClasses: (n) => `${n} classes`,
  tabItems: 'Items',
  tabCategories: 'Categories',
  tabClasses: 'Classes',
  addCategoriesWithoutTemplate: 'Add these categories without the template',
  categoryImportWarning:
    'This does not install the template. It only adds category definitions to Category Management. Merge may add or duplicate existing ids.',
  downloadCategoriesJson: 'Download categories JSON',
  categoryPacksTitle: 'Category packs',
  categoryPacksBlurb:
    'Standalone category definitions for Containd Category Management. These are not templates.',
  noPublicCategoryPacks: 'No public category packs yet.',
  addCategoriesInContaind: 'Add categories in Containd',
  downloadJson: 'Download JSON',
  categoryPackWarning:
    'This is not a template. Adding these categories may create new ids or duplicate ones you already have.',
  includedInTemplates: 'Included in templates',
  notUsedInTemplate: 'Not used in a public template yet.',
  authorsTitle: 'For authors',
  authorsBlurb:
    'Class, expression, and script packages for the Containd template editor. Download and import in the editor — they are not app installs.',
  noPublicAuthorPackages: 'No public author packages yet.',
  downloadForEditor: 'Download for template editor',
  authorPackageHint: 'Import this file in the Containd template editor. It is not an app install.',
  blocklyCaveat:
    'Editor packages include graphs that cannot be reconstructed from a published template.',
  authorKindClass: 'Class',
  authorKindExpression: 'Expression',
  authorKindScript: 'Script',
  compactCategories: 'Categories',
  siteNavAria: 'Site',
  navMenuOpen: 'Menu',
  navMenuClose: 'Close menu',
  footerReport: 'Report content',
  footerContact: 'Contact / DSA',
  favouriteTemplate: 'Favourite template',
  favouriteSaveError: 'Could not save favourite',
  favouriteRemoveError: 'Could not remove favourite',
  pagerAria: 'Pagination',
  recommendedGear: 'Recommended gear',
  searchOnAmazon: 'Search on Amazon',
  amazonDisclosure:
    'As an Amazon Associate, Containd may earn from qualifying purchases.',
  chromePreviewAlt: 'Containd chrome preview',
  wikiTocAria: 'On this page',
  thTemplate: 'Template',
  thAuthor: 'Author',
  thExampleSpace: 'Example Space',
  thPackage: 'Package',
  thProject: 'Project',
  templatePackageLink: 'Template package',
  sampleProjectLink: 'Template project',
  videoEmbedTitle: 'Video',
};

const DE: CatalogUiStrings = {
  ...EN,
  brand: 'Containd Vorlagenkatalog',
  brandShort: 'Containd Spaces',
  navCatalog: 'Vorlagen',
  navTemplates: 'Vorlagen',
  navCategoryPacks: 'Kategoriepakete',
  navAuthors: 'Für Autoren',
  navLists: 'Spaces',
  navDiscoverSpaces: 'Spaces entdecken',
  navDevelopers: 'Dokumentation',
  navDocs: 'Dokumentation',
  navDocsDevelopers: 'Vorlagen-Editoren',
  navDocsHandbook: 'Editor-Handbuch',
  navDocsCompany: 'Unternehmen',
  navTools: 'Werkzeuge',
  navToolsIos: 'Containd für Apple',
  navToolsAndroid: 'Containd für Android',
  navToolsWeb: 'Containd im Web',
  navToolsEditor: 'Vorlagen-Editor',
  navEditor: 'Editor',
  navExploreLists: 'Spaces',
  navGetApp: 'App holen',
  navCorporate: 'Unternehmen',
  navAccount: 'Konto',
  navSignIn: 'Anmelden',
  navProfile: 'Profil & Spaces',
  navViewProfile: 'Profil anzeigen',
  navSettings: 'Einstellungen',
  navSignOut: 'Abmelden',
  coercionLabel: 'Loslegen',
  coercionGetApp: 'Space erstellen — Containd App holen.',
  coercionPublishWeb: 'Spaces online erstellen und veröffentlichen',
  coercionTemplatesUseful: 'So helfen Vorlagen',
  coercionMakeTemplates: 'Vorlagen erstellen — Editor öffnen.',
  cornerRibbonText: 'Früh',
  cornerRibbonTitle: 'Frühe Entwicklung — Feedback willkommen',
  heroTitle: 'Containd Vorlagenkatalog',
  heroBlurb:
    'Offizielle Starter-Pakete und Vorlagen für die Containd-App. Durchsuchen, filtern und installieren — Autoren arbeiten im Vorlagen-Editor.',
  featured: 'Empfohlen',
  developers: 'Dokumentation',
  filterName: 'Name / Text',
  filterNamePh: 'Name, Klasse, …',
  filterLanguage: 'Sprache',
  filterAuthor: 'Autor',
  filterClass: 'Klasse',
  filterAny: 'Alle',
  filterAfter: 'Aktualisiert nach',
  filterBefore: 'Aktualisiert vor',
  filterStatus: 'Release-Status',
  filterEmpty: 'Keine Vorlagen passen zu diesen Filtern.',
  noPublic: 'Noch keine öffentlichen Vorlagen.',
  languages: 'Sprachen',
  classes: 'Klassen',
  none: 'Keine',
  moreInfo: 'Weitere Informationen',
  itemsInTemplate: 'Elemente in dieser Vorlage',
  backToTemplate: 'Zurück zur Vorlage',
  officialExample: 'Offizieller Beispiel-Space',
  publishedWithTemplate: 'Veröffentlicht mit dieser Vorlage',
  videoConsent: 'Erlauben Sie Video-Einbettungen in den Datenschutzeinstellungen, um die Übersicht abzuspielen.',
  previews: 'Vorschauen',
  video: 'Video',
  videoOptional: 'Optionale Übersicht',
  forDevelopers: 'Für Entwickler',
  developerGuide: 'Dokumentation & Entwickler-Wiki',
  openInApp: 'In Containd öffnen',
  downloadPackage: 'Vorlagenpaket herunterladen',
  viewExampleList: 'Beispiel-Space ansehen',
  downloadExampleCollection: 'Beispielsammlung herunterladen',
  openExampleInApp: 'Beispiel in Containd öffnen',
  downloadProject: 'Vorlagenprojekt herunterladen',
  exampleCollectionsHeading: 'Beispielsammlungen',
  noExampleCollections:
    'Noch keine Beispielsammlungen. Admins laden ein Sammlungs-ZIP separat hoch und tragen die URL bei der Freigabe ein.',
  updated: 'aktualisiert',
  created: 'erstellt',
  classHeading: 'Klasse',
  classBlurb: (n) => `Vorlagen, die diese Klasse definieren oder nutzen (${n}).`,
  noPublicClass: 'Keine öffentlichen Vorlagen',
  developersTitle: 'Über Vorlagen',
  developersIntro:
    'Kurzer Überblick: was Vorlagen sind, wie man sie installiert, und wie Containd Vorlagen-Skripte absichert.',
  templatesHeading: 'Was ist eine Vorlage?',
  templatesBlurb:
    'Eine Vorlage ist ein fertiges Layout für Containd: Elementtypen, Kategorien und optionales Verhalten, das du in die App installieren kannst.',
  templatesWhatLabel: 'Inhalt',
  templatesWhat:
    'Ein herunterladbares Paket (JSON plus Bilder und andere Medien), das die Containd-App versteht.',
  templatesInstallLabel: 'So nutzt du sie',
  templatesInstall:
    'Vom Katalog in die App installieren, oder einen Beispiel-Space auf containd.space öffnen, um sie zu sehen.',
  templatesEditorLabel: 'Wer sie erstellt',
  templatesClassesLabel: 'Klassen',
  templatesClasses:
    'Benannte Bausteine in einer Vorlage. Katalogseiten verlinken Vorlagen mit derselben Klasse.',
  safetyHeading: 'Skripte und Sicherheit',
  safetyIntro:
    'Manche Vorlagen enthalten kleine Skripte (z. B. Timer oder Aktionen). Das heißt nicht, dass beliebiger Code auf dieser Website läuft.',
  safetySandbox:
    'In der Containd-App laufen Vorlagen-Skripte nur in einer js-interpreter-Sandbox — einer eingeschränkten Umgebung, nicht als freies JavaScript auf dem Gerät.',
  safetyNotBrowser:
    'Beim Besuch dieses Katalogs oder eines veröffentlichten Spaces im Browser werden diese Vorlagen-Skripte nicht wie normales Website-JavaScript ausgeführt.',
  safetyOfficial:
    'Bevorzuge offizielle Katalog-Vorlagen von Autoren, denen du vertraust. Verdächtiges über den Link „Inhalt melden“ melden.',
  installHeading: 'Installation & Pakete',
  installPackageBlurb:
    'Jedes Vorlagenpaket liegt als eigenständige Datei unter /packages/{slug}/{version}.json auf dieser Website.',
  installHowBlurb:
    'Mit „In Containd öffnen“ installieren, das Paket herunterladen und in den Einstellungen importieren, oder Vorlagen in Discover in der App finden.',
  installHostsBlurb:
    'Hosts: catalog.containd.app (dieser Katalog) · containd.space (veröffentlichte Spaces) · Editor',
  sampleHeading: 'Vorlagenprojekt-Downloads',
  noSamples:
    'Noch keine Vorlagenprojekte. Admins können pro Eintrag eine Workspace-/Projekt-JSON-URL hinterlegen.',
  classesHeading: 'Klassen',
  classesBlurb:
    'Klassen sind gemeinsame Bausteine. Jede Klassenseite listet offizielle öffentliche Vorlagen, die diese Klasse definieren oder nutzen.',
  backToCatalog: 'Zurück zu Vorlagen',
  footerOfficial: 'Containd',
  footerEditor:
    'Spaces: containd.space · Vorlagen: catalog.containd.app · Editor: templates.containd.app · App: www.containd.app',
  footerEula: 'EULA',
  footerPrivacy: 'Datenschutz',
  footerTos: 'Nutzungsbedingungen',
  footerImprint: 'Impressum',
  homeTitle: 'Containd Vorlagenkatalog',
  homeDescription:
    'Offizielle Vorlagen für die Containd-App — Suche nach Name, Sprache, Autor, Klasse, Datum',
  developersPageTitle: 'Über Vorlagen',
  developersPageDescription:
    'Was Containd-Vorlagen sind, wie man sie installiert, und wie Vorlagen-Skripte in einer Sandbox bleiben',
  official: 'Offiziell',
  featuredBadge: 'empfohlen',
  statusAlpha: 'Alpha',
  statusBeta: 'Beta',
  statusStable: 'Stabil',
  statusPrerelease: 'Vorabversion',
  releaseNotes: 'Versionshinweise',
  langSwitcherLabel: 'Sprache',
  pagerPrev: 'Zurück',
  pagerNext: 'Weiter',
  pagerStatus: (page, totalPages, total) =>
    total === 0 ? 'Keine Ergebnisse' : `Seite ${page} von ${totalPages} · ${total} Vorlagen`,
  documentTitleSuffix: 'Containd',
  whatsIncluded: 'Enthalten',
  includedItems: (n) => `${n} Elemente`,
  includedCategories: (n) => `${n} Kategorien`,
  includedClasses: (n) => `${n} Klassen`,
  tabItems: 'Elemente',
  tabCategories: 'Kategorien',
  tabClasses: 'Klassen',
  addCategoriesWithoutTemplate: 'Diese Kategorien ohne die Vorlage hinzufügen',
  categoryImportWarning:
    'Das installiert die Vorlage nicht. Es fügt nur Kategoriedefinitionen zur Kategorieverwaltung hinzu. Zusammenführen kann IDs ergänzen oder verdoppeln.',
  downloadCategoriesJson: 'Kategorien-JSON herunterladen',
  categoryPacksTitle: 'Kategoriepakete',
  categoryPacksBlurb:
    'Eigenständige Kategoriedefinitionen für die Containd-Kategorieverwaltung. Das sind keine Vorlagen.',
  noPublicCategoryPacks: 'Noch keine öffentlichen Kategoriepakete.',
  addCategoriesInContaind: 'Kategorien in Containd hinzufügen',
  downloadJson: 'JSON herunterladen',
  categoryPackWarning:
    'Das ist keine Vorlage. Das Hinzufügen dieser Kategorien kann neue IDs anlegen oder vorhandene verdoppeln.',
  includedInTemplates: 'In Vorlagen enthalten',
  notUsedInTemplate: 'Noch in keiner öffentlichen Vorlage verwendet.',
  authorsTitle: 'Für Autoren',
  authorsBlurb:
    'Klassen-, Ausdrucks- und Skriptpakete für den Containd-Vorlagen-Editor. Herunterladen und im Editor importieren — keine App-Installation.',
  noPublicAuthorPackages: 'Noch keine öffentlichen Autorenpakete.',
  downloadForEditor: 'Für den Vorlagen-Editor herunterladen',
  authorPackageHint: 'Diese Datei im Containd-Vorlagen-Editor importieren. Das ist keine App-Installation.',
  blocklyCaveat:
    'Editor-Pakete enthalten Graphen, die sich aus einer veröffentlichten Vorlage nicht rekonstruieren lassen.',
  authorKindClass: 'Klasse',
  authorKindExpression: 'Ausdruck',
  authorKindScript: 'Skript',
  compactCategories: 'Kategorien',
  siteNavAria: 'Seite',
  navMenuOpen: 'Menü',
  navMenuClose: 'Menü schließen',
  footerReport: 'Inhalt melden',
  footerContact: 'Kontakt / DSA',
  favouriteTemplate: 'Vorlage merken',
  favouriteSaveError: 'Favorit konnte nicht gespeichert werden',
  favouriteRemoveError: 'Favorit konnte nicht entfernt werden',
  pagerAria: 'Seitennummerierung',
  recommendedGear: 'Empfohlenes Zubehör',
  searchOnAmazon: 'Auf Amazon suchen',
  amazonDisclosure: 'Als Amazon-Partner verdient Containd an qualifizierten Käufen.',
  chromePreviewAlt: 'Containd-Oberflächenvorschau',
  wikiTocAria: 'Auf dieser Seite',
  thTemplate: 'Vorlage',
  thAuthor: 'Autor',
  thExampleSpace: 'Beispiel-Space',
  thPackage: 'Paket',
  thProject: 'Projekt',
  templatePackageLink: 'Vorlagenpaket',
  sampleProjectLink: 'Vorlagenprojekt',
  videoEmbedTitle: 'Video',
};

const JP: CatalogUiStrings = {
  ...EN,
  brand: 'Containd テンプレートカタログ',
  brandShort: 'Containd Spaces',
  navCatalog: 'テンプレート',
  navTemplates: 'テンプレート',
  navCategoryPacks: 'カテゴリパック',
  navAuthors: '作者向け',
  navLists: 'スペース',
  navDiscoverSpaces: 'スペースを見つける',
  navDevelopers: 'ドキュメント',
  navDocs: 'ドキュメント',
  navDocsDevelopers: 'テンプレート編集者向け',
  navDocsHandbook: 'エディターハンドブック',
  navDocsCompany: '会社情報',
  navTools: 'ツール',
  navToolsIos: 'Containd（Apple）',
  navToolsAndroid: 'Containd（Android）',
  navToolsWeb: 'Containd（Web）',
  navToolsEditor: 'テンプレートエディター',
  navEditor: 'エディター',
  navExploreLists: 'スペース',
  navGetApp: 'アプリを入手',
  navCorporate: '会社情報',
  navAccount: 'アカウント',
  navSignIn: 'サインイン',
  navProfile: 'プロフィールとスペース',
  navViewProfile: 'プロフィールを見る',
  navSettings: '設定',
  navSignOut: 'サインアウト',
  coercionLabel: 'はじめる',
  coercionGetApp: 'スペースを作る — Containdアプリを入手。',
  coercionPublishWeb: 'スペースをオンラインで作成・公開',
  coercionTemplatesUseful: 'テンプレートの活用をチェック',
  coercionMakeTemplates: 'テンプレートを作る — エディターへ。',
  cornerRibbonText: '初期',
  cornerRibbonTitle: '開発初期です — フィードバック歓迎',
  heroTitle: 'Containd テンプレートカタログ',
  heroBlurb:
    'Containdアプリ向けの公式スターターパックとテンプレート。閲覧・絞り込み・インストール — 作成はテンプレートエディターで行います。',
  featured: 'おすすめ',
  developers: 'ドキュメント',
  filterName: '名前 / テキスト',
  filterNamePh: '名前、クラス…',
  filterLanguage: '言語',
  filterAuthor: '作者',
  filterClass: 'クラス',
  filterAny: 'すべて',
  filterAfter: '更新日（以降）',
  filterBefore: '更新日（以前）',
  filterStatus: 'リリース状態',
  filterEmpty: '条件に一致するテンプレートがありません。',
  noPublic: '公開テンプレートはまだありません。',
  languages: '言語',
  classes: 'クラス',
  none: 'なし',
  moreInfo: '詳細情報',
  itemsInTemplate: 'このテンプレートのアイテム',
  backToTemplate: 'テンプレートに戻る',
  officialExample: '公式サンプルスペース',
  publishedWithTemplate: 'このテンプレートで公開されたスペース',
  videoConsent: '概要動画を再生するには、プライバシー設定で埋め込みを許可してください。',
  previews: 'プレビュー',
  video: '動画',
  videoOptional: '任意の概要',
  forDevelopers: '開発者向け',
  developerGuide: 'ドキュメント・開発者Wiki',
  openInApp: 'Containdで開く',
  downloadPackage: 'テンプレートパッケージをダウンロード',
  viewExampleList: 'サンプルスペースを見る',
  downloadExampleCollection: 'サンプルコレクションをダウンロード',
  openExampleInApp: 'Containdでサンプルを開く',
  downloadProject: 'テンプレートプロジェクトをダウンロード',
  exampleCollectionsHeading: 'サンプルコレクション',
  noExampleCollections:
    'サンプルコレクションはまだありません。管理者がコレクションZIPを別途アップロードし、レビュー時にURLを設定します。',
  updated: '更新',
  created: '作成',
  classHeading: 'クラス',
  classBlurb: (n) => `このクラスを定義または使用するテンプレート（${n}）。`,
  noPublicClass: '公開テンプレートなし',
  developersTitle: 'テンプレートについて',
  developersIntro:
    'テンプレートとは何か、インストール方法、スクリプトを安全に扱う仕組みの短い案内です。',
  templatesHeading: 'テンプレートとは？',
  templatesBlurb:
    'テンプレートはContaind用の用意されたレイアウトです。アイテム種別、カテゴリ、任意の動作をアプリにインストールできます。',
  templatesWhatLabel: '中身',
  templatesWhat:
    'Containdアプリが理解するダウンロード可能なパッケージ（JSONと画像などのメディア）です。',
  templatesInstallLabel: '使い方',
  templatesInstall:
    'このカタログからアプリへインストールするか、containd.spaceのサンプルスペースで動作を確認できます。',
  templatesEditorLabel: '作成場所',
  templatesClassesLabel: 'クラス',
  templatesClasses:
    'テンプレート内の名前付き部品です。同じクラスを使うテンプレートはカタログで相互にリンクされます。',
  safetyHeading: 'スクリプトと安全',
  safetyIntro:
    '一部のテンプレートには小さなスクリプト（タイマーやカスタム操作など）が含まれます。これはこのサイトで任意のコードが動くという意味ではありません。',
  safetySandbox:
    'Containdアプリでは、テンプレートのスクリプトはjs-interpreterのサンドボックス内だけで実行されます。デバイス上の通常の無制限JavaScriptとしては動きません。',
  safetyNotBrowser:
    'このカタログや公開スペースをブラウザで見るだけでは、通常のウェブサイトのスクリプトのようにテンプレートスクリプトは実行されません。',
  safetyOfficial:
    '信頼できる作者の公式カタログテンプレートを優先してください。不審な内容は「コンテンツを報告」から連絡してください。',
  installHeading: 'インストールとパッケージ',
  installPackageBlurb:
    '各テンプレートパッケージはこのサイトの /packages/{slug}/{version}.json にある自己完結ファイルです。',
  installHowBlurb:
    '「Containdで開く」でインストール、パッケージをダウンロードして設定から読み込む、またはアプリ内Discoverから探せます。',
  installHostsBlurb:
    'ホスト: catalog.containd.app（このカタログ）· containd.space（公開スペース）· エディター',
  sampleHeading: 'テンプレートプロジェクトのダウンロード',
  noSamples:
    'テンプレートプロジェクトはまだありません。管理者がエントリごとにワークスペース/プロジェクトJSONのURLを設定できます。',
  classesHeading: 'クラス',
  classesBlurb:
    'クラスは共通の部品です。各クラスページには、そのクラスを定義または使用する公式公開テンプレートが一覧されます。',
  backToCatalog: 'テンプレートに戻る',
  footerOfficial: 'Containd',
  footerEditor:
    'スペース: containd.space · テンプレート: catalog.containd.app · エディター: templates.containd.app · アプリ: www.containd.app',
  footerPrivacy: 'プライバシーポリシー',
  footerTos: '利用規約',
  footerImprint: 'インプリント',
  homeTitle: 'Containd テンプレートカタログ',
  homeDescription: 'Containdアプリ向け公式テンプレート — 名前・言語・作者・クラス・日付で検索',
  developersPageTitle: 'テンプレートについて',
  developersPageDescription:
    'Containdテンプレートの説明、インストール方法、スクリプトがサンドボックスで動くこと',
  official: '公式',
  featuredBadge: 'おすすめ',
  statusAlpha: 'アルファ',
  statusBeta: 'ベータ',
  statusStable: '安定版',
  statusPrerelease: 'プレリリース',
  releaseNotes: 'リリースノート',
  langSwitcherLabel: '言語',
  pagerPrev: '前へ',
  pagerNext: '次へ',
  pagerStatus: (page, totalPages, total) =>
    total === 0 ? '結果なし' : `${page} / ${totalPages} ページ · ${total} 件`,
  documentTitleSuffix: 'Containd',
  whatsIncluded: '含まれるもの',
  includedItems: (n) => `${n} アイテム`,
  includedCategories: (n) => `${n} カテゴリ`,
  includedClasses: (n) => `${n} クラス`,
  tabItems: 'アイテム',
  tabCategories: 'カテゴリ',
  tabClasses: 'クラス',
  addCategoriesWithoutTemplate: 'テンプレートなしでこれらのカテゴリを追加',
  categoryImportWarning:
    'テンプレートはインストールされません。カテゴリ管理にカテゴリ定義だけが追加されます。結合すると既存IDが追加または重複する場合があります。',
  downloadCategoriesJson: 'カテゴリJSONをダウンロード',
  categoryPacksTitle: 'カテゴリパック',
  categoryPacksBlurb:
    'Containdのカテゴリ管理向けの独立したカテゴリ定義です。テンプレートではありません。',
  noPublicCategoryPacks: '公開カテゴリパックはまだありません。',
  addCategoriesInContaind: 'Containdにカテゴリを追加',
  downloadJson: 'JSONをダウンロード',
  categoryPackWarning:
    'これはテンプレートではありません。追加すると新しいIDが作られるか、既存IDと重複する場合があります。',
  includedInTemplates: 'テンプレートに含まれる',
  notUsedInTemplate: 'まだ公開テンプレートでは使われていません。',
  authorsTitle: '作者向け',
  authorsBlurb:
    'Containdテンプレートエディター向けのクラス・式・スクリプトパッケージです。エディターでダウンロードして取り込みます。アプリへのインストールではありません。',
  noPublicAuthorPackages: '公開の作者パッケージはまだありません。',
  downloadForEditor: 'テンプレートエディター用にダウンロード',
  authorPackageHint: 'Containdテンプレートエディターでこのファイルを取り込みます。アプリのインストールではありません。',
  blocklyCaveat:
    'エディターパッケージには、公開テンプレートからは再構築できないグラフが含まれます。',
  authorKindClass: 'クラス',
  authorKindExpression: '式',
  authorKindScript: 'スクリプト',
  compactCategories: 'カテゴリ',
  siteNavAria: 'サイト',
  navMenuOpen: 'メニュー',
  navMenuClose: 'メニューを閉じる',
  footerReport: 'コンテンツを報告',
  footerContact: 'お問い合わせ / DSA',
  favouriteTemplate: 'テンプレートをお気に入りに追加',
  favouriteSaveError: 'お気に入りを保存できませんでした',
  favouriteRemoveError: 'お気に入りを削除できませんでした',
  pagerAria: 'ページ送り',
  recommendedGear: 'おすすめの関連商品',
  searchOnAmazon: 'Amazonで検索',
  amazonDisclosure:
    'Amazonアソシエイトとして、Containdは適格な購入から収入を得ることがあります。',
  chromePreviewAlt: 'Containd画面プレビュー',
  wikiTocAria: 'このページの内容',
  thTemplate: 'テンプレート',
  thAuthor: '作者',
  thExampleSpace: 'サンプルスペース',
  thPackage: 'パッケージ',
  thProject: 'プロジェクト',
  templatePackageLink: 'テンプレートパッケージ',
  sampleProjectLink: 'テンプレートプロジェクト',
  videoEmbedTitle: '動画',
};

const BY_LOCALE: Record<string, CatalogUiStrings> = {
  en: EN,
  de: DE,
  jp: JP,
};

export function catalogUi(locale: string): CatalogUiStrings {
  const key = locale.toLowerCase().split('-')[0] ?? 'en';
  return BY_LOCALE[key] ?? EN;
}

export function isCatalogSiteLocale(locale: string): locale is CatalogSiteLocale {
  return (CATALOG_SITE_LOCALES as readonly string[]).includes(locale);
}

/** Display labels for the site language switcher. */
export const SITE_LOCALE_LABELS: Record<CatalogSiteLocale, string> = {
  en: 'EN',
  de: 'DE',
  jp: 'JP',
};
